/**
 * KAN-866: как подписать в шапке того, кто вошёл в кабинет.
 * Менеджер: имя из справочника (иначе имя и фамилия), с пометкой "менеджер".
 * Остальные: имя и фамилия, без них email.
 */
import { isManagerUser } from '@/lib/managerAccess';

export interface DisplayNameUserLike {
  email?: string;
  first_name?: string;
  last_name?: string;
}

export interface CabinetUserLike extends DisplayNameUserLike {
  role?: string;
  manager_name?: string | null;
}

export interface CabinetUserLabel {
  name: string;
  isManager: boolean;
}

/** Имя и фамилия через пробел (без пустых частей), без них email. */
export function userDisplayName(user: DisplayNameUserLike): string {
  const fullName = [user.first_name, user.last_name]
    .map((part) => (part ?? '').trim())
    .filter(Boolean)
    .join(' ');
  return fullName || (user.email ?? '').trim();
}

export function cabinetUserLabel(user: CabinetUserLike): CabinetUserLabel {
  const isManager = isManagerUser(user);
  const managerName = isManager ? (user.manager_name ?? '').trim() : '';
  const name = managerName || userDisplayName(user);
  return { name, isManager };
}
